export default __webpack_public_path__ + "static/media/Headdress of the Sanguine Disciple.547b4fd0.jpg";